"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/EUFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_72)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_72`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M0 0H24V24H0V0Z",
					fill: "#003399"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9978 2.66064L12.2972 3.58141H13.2702L12.4866 4.15082L12.7816 5.07259L11.9979 4.50317L11.2142 5.07259L11.5135 4.15129L10.7299 3.58188H11.6986L11.9978 2.66064ZM7.99783 3.72735L8.29718 4.64812H9.27024L8.48653 5.21753L8.78159 6.13929L7.99783 5.56988L7.21412 6.13929L7.51347 5.218L6.72977 4.64853H7.69847L7.99783 3.72735ZM5.06447 6.66065L5.36383 7.58141H6.33688L5.55318 8.15082L5.84824 9.07259L5.06447 8.50317L4.28077 9.07259L4.58012 8.15129L3.79641 7.58188H4.76512L5.06447 6.66065ZM3.99783 10.6606L4.29718 11.5814H5.27024L4.48653 12.1509L4.78159 13.0727L3.99783 12.5032L3.21412 13.0727L3.51347 12.1513L2.72977 11.5819H3.69847L3.99783 10.6606ZM5.06447 14.6606L5.36383 15.5815H6.33688L5.55318 16.1509L5.84824 17.0726L5.06447 16.5032L4.28077 17.0726L4.58012 16.1514L3.79641 15.5819H4.76512L5.06447 14.6606ZM7.99783 17.594L8.29718 18.5148H9.27024L8.48653 19.0842L8.78159 20.006L7.99783 19.4366L7.21412 20.006L7.51347 19.0848L6.72977 18.5153H7.69847L7.99783 17.594ZM15.9978 3.72735L16.2972 4.64812H17.2702L16.4866 5.21753L16.7816 6.13929L15.9979 5.56988L15.2141 6.13929L15.5135 5.218L14.7299 4.64853H15.6986L15.9978 3.72735ZM18.9312 6.66065L19.2305 7.58141H20.2036L19.4199 8.15082L19.7149 9.07259L18.9312 8.50317L18.1475 9.07259L18.4469 8.15129L17.6632 7.58188H18.6319L18.9312 6.66065ZM19.9978 10.6606L20.2972 11.5814H21.2702L20.4866 12.1509L20.7816 13.0727L19.9979 12.5032L19.2142 13.0727L19.5135 12.1513L18.7299 11.5819H19.6986L19.9978 10.6606ZM18.9312 14.6606L19.2305 15.5815H20.2036L19.4199 16.1509L19.7149 17.0726L18.9312 16.5032L18.1475 17.0726L18.4469 16.1514L17.6632 15.5819H18.6319L18.9312 14.6606ZM11.9978 18.6606L12.2972 19.5815H13.2702L12.4866 20.1509L12.7816 21.0726L11.9979 20.5032L11.2142 21.0726L11.5135 20.1514L10.7299 19.5819H11.6986L11.9978 18.6606ZM15.9978 17.594L16.2972 18.5148H17.2702L16.4866 19.0842L16.7816 20.006L15.9979 19.4366L15.2142 20.006L15.5135 19.0847L14.7299 18.5153H15.6986L15.9978 17.594Z",
					fill: "#FFCC00"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_72`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as EUFlag };
